import api from "../../api";

class CostCenter {

  getByUserId(userId){
      return api.get(`user-cost-center/${userId}`)
  }

}

export default  new CostCenter();
